import { Navigate, Route, Routes } from 'react-router-dom'
import Header from './components/Header'
import RequireAuth from './components/RequireAuth'
import Tower from './routes/Tower'
import Login from './routes/Login'
import ModuleView from './routes/ModuleView'
import LessonView from './routes/LessonView'
import Dashboard from './routes/Dashboard'
import Account from './routes/Account'
import Boss from './routes/Boss'
import Patrol from './routes/Patrol'
import Collection from './routes/Collection'

export default function App() {
  return (
    <div className="app">
      <Header />
      <main className="main">
        <Routes>
          <Route path="/" element={<Tower />} />
          <Route path="/login" element={<Login />} />
          <Route path="/floor/:slug" element={<ModuleView />} />
          <Route path="/floor/:slug/boss" element={<Boss />} />
          <Route path="/floor/:moduleSlug/:lessonSlug" element={<LessonView />} />
          <Route path="/collection" element={<Collection />} />
          <Route
            path="/patrol"
            element={
              <RequireAuth>
                <Patrol />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/account"
            element={
              <RequireAuth>
                <Account />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <footer className="footer">
        <span>Stack School</span>
        <span className="dim">
          Every example on this site is this site. Nothing here is a mock.
        </span>
      </footer>
    </div>
  )
}
